@for (menuItem of menuItems; track menuItem) {
  <li class="main-menu_item">
    <a class="main-menu_item-link" [routerLink]="menuItem.routerLink"
      [routerLinkActiveOptions]="menuItem.routerLinkActiveOptions || defaultRouterLinkActiveOptions"
      [routerLinkActive]="routerLinkActiveClass">
      <div>
        @if (menuItem.icon) {
          <svg class="main-menu_item-icon">
            <use [attr.xlink:href]="menuItem.icon"></use>
          </svg>
        }
        <div class="main-menu_item-label">{{menuItem.label | l10n}}</div>
      </div>
      <ng-container [mainMenuDropdownCustomItemRenderer]="menuItem.itemComponent"></ng-container>
    </a>
  </li>
}
@if (logout) {
  <div class="main-menu_item -logout" (click)="logoutClick()">
    <svg class="main-menu_item-icon">
      <use xlink:href="#main-menu-logout"></use>
    </svg>
    <div class="main-menu_item-label">{{'components.main-menu.logout' | l10n}}</div>
  </div>
}
